import axios from 'axios';
import { AdminAPI } from '../../constants/API';
import { commonHeaders } from '../../constants/HeadersAPI';

export const dataUrlToFile = (dataUrl: string, fileName = 'photo.jpg'): File => {
  const [header, base64] = dataUrl.split(',');
  const mime = header.match(/:(.*?);/)?.[1] ?? 'image/jpeg';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], fileName, { type: mime });
};

export const uploadEmployeePhoto = async (
  userId: number,
  dataUrl: string
): Promise<string> => {
  const formData = new FormData();
  formData.append('file', dataUrlToFile(dataUrl));
  const { data } = await axios.post<{ url: string }>(
    AdminAPI.uploadUserPhoto(userId),
    formData,
    {
      ...commonHeaders(),
      headers: {
        ...commonHeaders().headers,
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return data.url;
};

export const deleteEmployeePhoto = async (userId: number): Promise<void> => {
  await axios.delete(AdminAPI.deleteUserPhoto(userId), commonHeaders());
};

export const syncEmployeePhoto = async (
  userId: number,
  photo: string | null,
  initialPhotoUrl: string | null
): Promise<void> => {
  const photoChanged = photo !== initialPhotoUrl;
  if (!photoChanged) {
    return;
  }
  if (photo?.startsWith('data:')) {
    await uploadEmployeePhoto(userId, photo);
    return;
  }
  if (!photo && initialPhotoUrl) {
    await deleteEmployeePhoto(userId);
  }
};
